export const COLORS = {
  background: '#101113',
  accentBackground: '#1E1F21',
  /** Cards / panels on analytics dark surfaces (Base, charts). */
  cardBackground: '#16181c',
  primary: '#4485CF',
  text: '#f0f0f0',
  checkbox: '#C1C2C5',
  red: '#b53a3a',
  activeNavlink: '#25262B',
};
